import i18next from "src/i18n/config";

import { Build } from "../products/types";

export const createRolloutTag = (rollout: number | undefined): API.Tag | null => {
    return rollout !== undefined && rollout !== 100
        ? {
              key: "rollout",
              value: String(rollout) + "%",
              type: "scoped",
          }
        : null;
};

export const createBuildVariantTag = (build: Build): API.Tag | null => {
    let variant = null;

    if (build.configOverride && "buildVariant" in build.configOverride) {
        variant = build.configOverride.buildVariant as string;
    } else if (build.configSnapshot && build.configSnapshot?.buildVariant) {
        variant = build.configSnapshot.buildVariant;
    }

    if (variant) {
        return {
            key: "variant",
            value: variant,
            type: "scoped",
        };
    }
    return null;
};

export const createTriggerTag = (build: Build): API.Tag | null => {
    if (build.buildType === "Nightly") {
        return { key: i18next.t("common:tag.trigger"), value: i18next.t("common:tag.automatic"), type: "scoped" };
    }
    if (build.buildType === "Manual") {
        return { key: i18next.t("common:tag.trigger"), value: i18next.t("common:tag.manual"), type: "scoped" };
    }
    return null;
};

const compareTagText = (a: string | undefined, b: string | undefined) =>
    (a ?? "").localeCompare(b ?? "", undefined, { numeric: true });

/**
 * Orders tags by key and, for equal keys, by value. Numbers inside the text compare by their value, so "v9" comes
 * before "v10". Returns a new array.
 */
export const sortTags = <T extends API.Tag>(tags: readonly T[]): T[] =>
    [...tags].sort((a, b) => compareTagText(a.key, b.key) || compareTagText(a.value, b.value));

/**
 * React key for a rendered tag. Tags can share a key with different values, so the value is part of it.
 */
export const getTagReactKey = (tag: API.Tag) => JSON.stringify([tag.key, tag.value]);
